<template>
    <div class="container">
        <div class="header">
            <Icon
                class="cursor-p"
                type="ios-arrow-back"
                size="40"
                @click="goReturn"
            />
            <div class="header-select" v-if="diy_id == 1">
                <Select
                    class="w150"
                    v-model="link_id"
                    filterable
                    label-in-value
                    placeholder="页面名称"
                    @on-change="changePage"
                >
                    <Option
                        v-for="item in linkLists"
                        :value="item.id"
                        :key="item.id"
                        >{{ item.title }}</Option
                    >
                </Select>
            </div>
        </div>
        <div class="content">
            <div class="content-component">
                <!-- 背景设置，DIY模板(产品模板)有页面名称 查询模板没有页面名称 -->
                <backgroundSet
                    :diy_id="diy_id"
                    :title="title"
                    :backgroundData="backgroundData"
                    @update-value="handleUpdateValue"
                    @update-title="handleUpdateTitle"
                ></backgroundSet>
                <!-- 基本组件 公司组件，查询模板没有产品组件 -->
                <basicComponent
                    :diy_id="diy_id"
                    :active_id="active_id"
                    :formData="formData"
                    :popData="popData"
                    ref="childRef"
                ></basicComponent>
            </div>
            <div class="content-phone">
                <!-- 删除组件 -->
                <div
                    class="del-btn"
                    v-if="operateData.visable"
                    :style="`top: ${
                        operateData.top +
                        operateData.first_top -
                        operateData.top_cha
                    }px;left: ${operateData.left}px;`"
                >
                    <!-- 有弹框组件 index==2 没有上移 -->
                    <template
                        v-if="
                            operateData.index == 2 &&
                            formData.findIndex((item) => item.type == 21) != -1
                        "
                    ></template>
                    <template v-else>
                        <!-- 新建的情况下 false-->
                        <template
                            v-if="!formData.some((item) => item.type == 0)"
                        >
                            <Icon
                                v-if="
                                    operateData.type != 21 &&
                                    operateData.index != 0
                                "
                                type="ios-arrow-up"
                                size="24"
                                color="#999999"
                                @click="goMoveUp(operateData.index)"
                            />
                        </template>
                        <!-- 新建的情况下 true-->
                        <template v-else>
                            <Icon
                                v-if="
                                    operateData.type != 21 &&
                                    operateData.index != 1
                                "
                                type="ios-arrow-up"
                                size="24"
                                color="#999999"
                                @click="goMoveUp(operateData.index)"
                            />
                        </template>
                    </template>
                    <!-- 最后一项 -->
                    <template v-if="formData.length - 1 == operateData.index">
                        <Icon
                            type="ios-arrow-down"
                            size="24"
                            color="#999999"
                            @click="goMoveDown(operateData.index)"
                        />
                    </template>
                    <template v-else>
                        <Icon
                            v-if="operateData.type != 21"
                            type="ios-arrow-down"
                            size="24"
                            color="#999999"
                            @click="goMoveDown(operateData.index)"
                        />
                    </template>
                    <Icon
                        class="mt12 mb12"
                        v-if="operateData.type != 21 && operateData.type != -1"
                        type="md-add"
                        size="24"
                        color="#999999"
                        @click="callMenuClick(operateData.type)"
                    />
                    <Icon
                        class="mt12 mb12"
                        v-if="operateData.type == 21"
                        type="md-brush"
                        size="24"
                        color="#999999"
                        @click="openPop"
                    />
                    <Icon
                        v-if="operateData.type != -1"
                        type="md-trash"
                        size="24"
                        color="#999999"
                        @click.stop.prevent="delBtn(operateData.index)"
                    />
                </div>
                <div class="phone-div">
                    <div
                        class="phone"
                        ref="xqBox"
                        :style="{
                            ...(backgroundData.content.bg_color && {
                                backgroundColor:
                                    backgroundData.content.bg_color,
                            }),
                            ...(backgroundData.content.imgs.picview &&
                                backgroundData.content.bgValue && {
                                    backgroundImage: `url(${backgroundData.content.imgs.picview})`,
                                }),
                        }"
                    >
                        <!-- 弹窗组件 -->
                        <popComponent
                            :popData="popData"
                            :popValue.sync="popValue"
                        ></popComponent>
                        <draggable
                            class="w375"
                            v-model="formData"
                            chosen-class="chosen"
                            force-fallback="true"
                            group="people"
                            animation="500"
                            :handle="'.dragg'"
                            @start="onStart"
                            @end="onEnd"
                        >
                            <transition-group>
                                <div
                                    v-for="(items, index) in formData"
                                    :key="index + 'a'"
                                    @click.stop.prevent="
                                        clickActive(items, index, $event)
                                    "
                                >
                                    <div
                                        :class="
                                            active_id == index
                                                ? 'phone-active'
                                                : 'phone-default'
                                        "
                                    >
                                        <!-- 搜索组件 -->
                                        <searchComponent
                                            class="dragg"
                                            :componentsData="items"
                                        ></searchComponent>
                                        <!-- 图文导航 -->
                                        <imageTxtNav
                                            class="dragg"
                                            :componentsData="items"
                                        ></imageTxtNav>
                                        <!-- 轮播广告 -->
                                        <rotatingAdvertisement
                                            class="dragg"
                                            :componentsData="items"
                                            :bg_color="
                                                backgroundData.content.bg_color
                                            "
                                        ></rotatingAdvertisement>
                                        <!-- 公告 -->
                                        <noticeComponent
                                            class="dragg"
                                            :componentsData="items"
                                        ></noticeComponent>
                                        <!-- 标题 -->
                                        <titleComponent
                                            class="dragg"
                                            :componentsData="items"
                                        ></titleComponent>
                                        <!-- 图片广告 -->
                                        <displayAdvertising
                                            class="dragg"
                                            :componentsData="items"
                                            :bg_color="
                                                backgroundData.content.bg_color
                                            "
                                        ></displayAdvertising>
                                        <!-- 视频 -->
                                        <videoComponent
                                            class="dragg"
                                            :componentsData="items"
                                        ></videoComponent>
                                        <!-- 文章列表 -->
                                        <articleListComponent
                                            class="dragg"
                                            :componentsData="items"
                                        ></articleListComponent>
                                        <!-- 图文详情 -->
                                        <imageTxtDetails
                                            class="dragg"
                                            :componentsData="items"
                                        ></imageTxtDetails>
                                        <!-- 弹窗组件 -->
                                        <div
                                            class="pop"
                                            v-if="items.type == 21"
                                        >
                                            弹窗组件
                                        </div>
                                        <!-- 营业执照 -->
                                        <businessLicense
                                            class="dragg"
                                            :componentsData="items"
                                            :companyData="companyData"
                                        ></businessLicense>
                                        <!-- 其他资质 -->
                                        <otherQualifications
                                            class="dragg"
                                            :componentsData="items"
                                            :companyData="companyData"
                                        ></otherQualifications>
                                        <!-- 公司图片 -->
                                        <pictureComponent
                                            class="dragg"
                                            :componentsData="items"
                                            :companyData="companyData"
                                        ></pictureComponent>
                                        <!-- 公司信息 -->
                                        <companyInformation
                                            class="dragg"
                                            :componentsData="items"
                                            :companyData="companyData"
                                        ></companyInformation>
                                        <!-- 代理商信息 -->
                                        <agentInformation
                                            class="dragg"
                                            :componentsData="items"
                                        ></agentInformation>
                                        <!-- 产品属性 -->
                                        <productAttributes
                                            class="dragg"
                                            :componentsData="items"
                                        ></productAttributes>
                                        <!-- 产品样册 -->
                                        <productBrochure
                                            class="dragg"
                                            :componentsData="items"
                                        ></productBrochure>
                                        <!-- 产品质检报告 -->
                                        <productInspection
                                            class="dragg"
                                            :componentsData="items"
                                        ></productInspection>
                                        <!-- 实例节点 -->
                                        <instanceNode
                                            class="dragg"
                                            :componentsData="items"
                                        ></instanceNode>
                                        <!-- 查询结果 -->
                                        <queryResults
                                            class="dragg"
                                            :componentsData="items"
                                        ></queryResults>
                                        <!-- 产品信息 -->
                                        <productInformation
                                            class="dragg"
                                            :componentsData="items"
                                        ></productInformation>
                                        <!-- 产品图片 -->
                                        <productImages
                                            class="dragg"
                                            :componentsData="items"
                                            :bg_color="
                                                backgroundData.content.bg_color
                                            "
                                        ></productImages>
                                        <!-- 批次属性 -->
                                        <batchAttributes
                                            class="dragg"
                                            :componentsData="items"
                                        ></batchAttributes>
                                        <!-- 批次质检报告 -->
                                        <batchInspection
                                            class="dragg"
                                            :componentsData="items"
                                        ></batchInspection>
                                        <!-- 监测数据 -->
                                        <monitor
                                            class="dragg"
                                            :componentsData="items"
                                        ></monitor>
                                        <!-- 质保信息 -->
                                        <warranty
                                            class="dragg"
                                            :componentsData="items"
                                        ></warranty>
                                    </div>
                                </div>
                            </transition-group>
                        </draggable>
                    </div>
                </div>
            </div>
            <div class="content-style">
                <!-- 搜索组件 -->
                <searchStyle
                    v-if="newFormData.content && newFormData.type == -1"
                    :newFormData="newFormData"
                ></searchStyle>
                <!-- 背景设置 -->
                <backgroundStyle
                    v-if="!newFormData.content || newFormData.type == 0"
                    :backgroundData="backgroundData"
                ></backgroundStyle>
                <!-- 图文导航 -->
                <imageTxtStyle
                    v-if="newFormData.content && newFormData.type == 1"
                    :newFormData="newFormData"
                    :diy_id="diy_id"
                    :linkList="linkList"
                ></imageTxtStyle>
                <!-- 轮播广告 -->
                <rotatingStyle
                    v-if="newFormData.content && newFormData.type == 2"
                    :newFormData="newFormData"
                    :diy_id="diy_id"
                    :linkList="linkList"
                ></rotatingStyle>
                <!-- 公告 -->
                <noticeStyle
                    v-if="newFormData.content && newFormData.type == 3"
                    :newFormData="newFormData"
                ></noticeStyle>
                <!-- 标题 -->
                <titleStyle
                    v-if="newFormData.content && newFormData.type == 4"
                    :newFormData="newFormData"
                ></titleStyle>
                <!-- 图片广告 -->
                <displayAdvertisingStyle
                    v-if="newFormData.content && newFormData.type == 5"
                    :newFormData="newFormData"
                    :diy_id="diy_id"
                    :linkList="linkList"
                ></displayAdvertisingStyle>
                <!-- 视频 -->
                <videoStyle
                    v-if="newFormData.content && newFormData.type == 6"
                    :newFormData="newFormData"
                ></videoStyle>
                <!-- 文章列表 -->
                <articleListStyle
                    v-if="newFormData.content && newFormData.type == 7"
                    :newFormData="newFormData"
                ></articleListStyle>
                <!-- 图文详情 -->
                <imageTxtInfoStyle
                    v-if="newFormData.content && newFormData.type == 8"
                    :newFormData="newFormData"
                ></imageTxtInfoStyle>
                <!-- 弹窗组件 -->
                <popStyle
                    v-if="newFormData.content && newFormData.type == 21"
                    :newFormData="newFormData"
                    :diy_id="diy_id"
                    :linkList="linkList"
                ></popStyle>
                <!-- 营业执照 -->
                <businessLicenseStyle
                    v-if="newFormData.content && newFormData.type == 9"
                    :newFormData="newFormData"
                ></businessLicenseStyle>
                <!-- 其他资质 -->
                <otherStyle
                    v-if="newFormData.content && newFormData.type == 10"
                    :newFormData="newFormData"
                ></otherStyle>
                <!-- 公司图片 -->
                <pictureStyle
                    v-if="newFormData.content && newFormData.type == 11"
                    :newFormData="newFormData"
                ></pictureStyle>
                <!-- 公司信息 -->
                <companyInfoStyle
                    v-if="newFormData.content && newFormData.type == 12"
                    :newFormData="newFormData"
                ></companyInfoStyle>
                <!-- 代理商信息 -->
                <agentInfoStyle
                    v-if="newFormData.content && newFormData.type == 20"
                    :newFormData="newFormData"
                ></agentInfoStyle>
                <!-- 产品属性 -->
                <productAttributeStyle
                    v-if="newFormData.content && newFormData.type == 13"
                    :newFormData="newFormData"
                ></productAttributeStyle>
                <!-- 产品样册 -->
                <productBrochureStyle
                    v-if="newFormData.content && newFormData.type == 14"
                    :newFormData="newFormData"
                ></productBrochureStyle>
                <!-- 产品质检报告 -->
                <productInspectionStyle
                    v-if="newFormData.content && newFormData.type == 15"
                    :newFormData="newFormData"
                ></productInspectionStyle>
                <!-- 实例节点 -->
                <instanceNodeStyle
                    v-if="newFormData.content && newFormData.type == 16"
                    :newFormData="newFormData"
                ></instanceNodeStyle>
                <!-- 查询结果 -->
                <queryResultStyle
                    v-if="newFormData.content && newFormData.type == 17"
                    :newFormData="newFormData"
                ></queryResultStyle>
                <!-- 产品信息 -->
                <productInfoStyle
                    v-if="newFormData.content && newFormData.type == 18"
                    :newFormData="newFormData"
                ></productInfoStyle>
                <!-- 产品图片 -->
                <productImgStyle
                    v-if="newFormData.content && newFormData.type == 19"
                    :newFormData="newFormData"
                ></productImgStyle>
                <!-- 批次属性 -->
                <batchAttributeStyle
                    v-if="newFormData.content && newFormData.type == 22"
                    :newFormData="newFormData"
                ></batchAttributeStyle>
                <!-- 批次质检报告 -->
                <batchInspectionStyle
                    v-if="newFormData.content && newFormData.type == 23"
                    :newFormData="newFormData"
                ></batchInspectionStyle>
                <!-- 监测数据 -->
                <monitorStyle
                    v-if="newFormData.content && newFormData.type == 24"
                    :newFormData="newFormData"
                ></monitorStyle>
                <!-- 质保信息 -->
                <warrantyStyle
                    v-if="newFormData.content && newFormData.type == 25"
                    :newFormData="newFormData"
                ></warrantyStyle>
            </div>
        </div>
        <div class="footer">
            <Button class="theme-bc theme-default-color" @click="goSubmit"
                >确定</Button
            >
        </div>
    </div>
</template>

<script>
import {
    template_diy_save_manage,
    template_diy_manage_info,
    template_modify_query,
    template_query_content,
    system_company_index,
    diy_manage_select,
} from "@/api/index";
import draggable from "vuedraggable";
import imageTxtNav from "@/components/diyPhone/imageTxtNav.vue";
import searchComponent from "@/components/diyPhone/searchComponent.vue";
import rotatingAdvertisement from "@/components/diyPhone/rotatingAdvertisement.vue";
import noticeComponent from "@/components/diyPhone/noticeComponent.vue";
import titleComponent from "@/components/diyPhone/titleComponent.vue";
import displayAdvertising from "@/components/diyPhone/displayAdvertising.vue";
import videoComponent from "@/components/diyPhone/videoComponent.vue";
import articleListComponent from "@/components/diyPhone/articleListComponent.vue";
import imageTxtDetails from "@/components/diyPhone/imageTxtDetails.vue";
import businessLicense from "@/components/diyPhone/businessLicense.vue";
import otherQualifications from "@/components/diyPhone/otherQualifications.vue";
import pictureComponent from "@/components/diyPhone/pictureComponent.vue";
import companyInformation from "@/components/diyPhone/companyInformation.vue";
import agentInformation from "@/components/diyPhone/agentInformation.vue";
import productAttributes from "@/components/diyPhone/productAttributes.vue";
import productBrochure from "@/components/diyPhone/productBrochure.vue";
import productInspection from "@/components/diyPhone/productInspection.vue";
import batchInspection from "@/components/diyPhone/batchInspection.vue";
import monitor from "@/components/diyPhone/monitor.vue";
import warranty from "@/components/diyPhone/warranty.vue";
import instanceNode from "@/components/diyPhone/instanceNode.vue";
import queryResults from "@/components/diyPhone/queryResults.vue";
import productInformation from "@/components/diyPhone/productInformation.vue";
import productImages from "@/components/diyPhone/productImages.vue";
import popComponent from "@/components/diyPhone/popComponent.vue";
import searchStyle from "@/components/diyStyle/searchStyle.vue";
import backgroundStyle from "@/components/diyStyle/backgroundStyle.vue";
import imageTxtStyle from "@/components/diyStyle/imageTxtStyle.vue";
import rotatingStyle from "@/components/diyStyle/rotatingStyle.vue";
import noticeStyle from "@/components/diyStyle/noticeStyle.vue";
import titleStyle from "@/components/diyStyle/titleStyle.vue";
import displayAdvertisingStyle from "@/components/diyStyle/displayAdvertisingStyle.vue";
import videoStyle from "@/components/diyStyle/videoStyle.vue";
import articleListStyle from "@/components/diyStyle/articleListStyle.vue";
import imageTxtInfoStyle from "@/components/diyStyle/imageTxtInfoStyle.vue";
import popStyle from "@/components/diyStyle/popStyle.vue";
import businessLicenseStyle from "@/components/diyStyle/businessLicenseStyle.vue";
import otherStyle from "@/components/diyStyle/otherStyle.vue";
import pictureStyle from "@/components/diyStyle/pictureStyle.vue";
import companyInfoStyle from "@/components/diyStyle/companyInfoStyle.vue";
import agentInfoStyle from "@/components/diyStyle/agentInfoStyle.vue";
import productAttributeStyle from "@/components/diyStyle/productAttributeStyle.vue";
import productBrochureStyle from "@/components/diyStyle/productBrochureStyle.vue";
import productInspectionStyle from "@/components/diyStyle/productInspectionStyle.vue";
import batchInspectionStyle from "@/components/diyStyle/batchInspectionStyle.vue";
import monitorStyle from "@/components/diyStyle/monitorStyle.vue";
import warrantyStyle from "@/components/diyStyle/warrantyStyle.vue";
import instanceNodeStyle from "@/components/diyStyle/instanceNodeStyle.vue";
import queryResultStyle from "@/components/diyStyle/queryResultStyle.vue";
import productInfoStyle from "@/components/diyStyle/productInfoStyle.vue";
import productImgStyle from "@/components/diyStyle/productImgStyle.vue";
import backgroundSet from "@/components/diyComponent/backgroundSet.vue";
import basicComponent from "@/components/diyComponent/basicComponent.vue";
import batchAttributes from "@/components/diyPhone/batchAttributes.vue";
import batchAttributeStyle from "@/components/diyStyle/batchAttributeStyle.vue";
export default {
    components: {
        draggable,
        imageTxtNav,
        searchComponent,
        rotatingAdvertisement,
        noticeComponent,
        titleComponent,
        displayAdvertising,
        videoComponent,
        articleListComponent,
        imageTxtDetails,
        businessLicense,
        otherQualifications,
        pictureComponent,
        companyInformation,
        agentInformation,
        productAttributes,
        productBrochure,
        productInspection,
        batchInspection,
        monitor,
        warranty,
        instanceNode,
        queryResults,
        productInformation,
        productImages,
        popComponent,
        backgroundStyle,
        searchStyle,
        imageTxtStyle,
        rotatingStyle,
        noticeStyle,
        titleStyle,
        displayAdvertisingStyle,
        videoStyle,
        articleListStyle,
        imageTxtInfoStyle,
        popStyle,
        businessLicenseStyle,
        otherStyle,
        pictureStyle,
        companyInfoStyle,
        agentInfoStyle,
        productAttributeStyle,
        productBrochureStyle,
        productInspectionStyle,
        batchInspectionStyle,
        monitorStyle,
        warrantyStyle,
        instanceNodeStyle,
        queryResultStyle,
        productInfoStyle,
        productImgStyle,
        backgroundSet,
        basicComponent,
        batchAttributes,
        batchAttributeStyle,
    },
    data() {
        return {
            diy_id: 0,
            id: "",
            diy_template_id: "",
            title: "",
            content: [],
            operateData: {
                top: 0,
                left: 0,
                visable: false,
                first_top: 0,
                top_cha: 0,
                index: 0,
                type: 0,
            },
            formData: [],
            active_id: -1,
            newFormData: {},
            backgroundData: {
                type: 0,
                name: "背景设置",
                content: {
                    version: 1,
                    bg_color: "#ccc",
                    bgValue: 0,
                    imgs: { value: "", picview: "" },
                },
            },
            linkList: [],
            companyData: {
                desc: "",
                address: "",
                mobile: "",
                contact: "",
                company_name: "",
                logo: "",
                show_logo: "",
                license: "",
                show_license: "",
                pic: "",
                other: "",
                show_other: [],
                show_pic: [],
            },
            searchData: {
                type: -1,
                name: "搜索组件",
                content: {
                    version: 2,
                    text: "提示文字",
                    position: "left",
                    text_color: "#000",
                    search_color: "#fff",
                    border_color: "#FF761D ",
                    bgs_color: "#FF761D ",
                    btn_text: "点击查询",
                    btn_bg_color: "#FF761D ",
                    btn_border_color: "#FF761D ",
                    height: 40,
                    btn_height: 40,
                    box_bg_color: "#fff",
                    imgs: {
                        value: "",
                        picview:
                            "https://suyuan.hulianzaowu.com/icon/diys/scan.png",
                    },
                    bg_color: "#fff",
                    bg_value: 0,
                    bg_img: { value: "", picview: "" },
                    marginData: { top: 0, left: 0 },
                    paddingData: { top: 12, left: 12 },
                    radiusData: { top: 0, bottom: 0 },
                    header: { radius: 4 },
                    footer: { radius: 4 },
                    style_value: "1",
                    search_mt: 12,
                    search_img: { value: "", picview: "" },
                },
            },
            linkLists: [],
            link_id: "",
            link_value: false,
            popValue: false,
            popData: {
                type: 21,
                name: "弹窗组件",
                content: {
                    version: 1,
                    bg_height: 180,
                    bg_width: 300,
                    style_value: "1",
                    btn_value: "2", //按钮设置 - 单按钮
                    title: "品质保证",
                    title_size: "18",
                    title_color: "#000",
                    text: "该产品为本公司原装品质，请放心购买以及使用！",
                    text_position: "left", //文字位置
                    text_size: "14",
                    text_color: "#000",
                    btn_text: "确 认",
                    btn_bg_color: "#FF761D ",
                    btn_border_color: "#FF761D ",
                    txt_color: "#fff",
                    action_id: 1,
                    link_id: 1,
                    link_name: "",
                    btn_text2: "取消",
                    btn_bg_color2: "#ccc",
                    btn_border_color2: "#ccc",
                    txt_color2: "#fff",
                    action_id2: 1,
                    link_id2: 1,
                    link_name2: "",
                    cancel_value1: "3", //关闭方式
                    cancel_position_value1: "1",
                    cancel_value2: "3", //关闭方式
                    cancel_position_value2: "1",
                    countdown: "5",
                    countdown_bg_color: "#000",
                    countdown_opacity: "50",
                    countdown_text_color: "#fff",
                    bg_color: "#fff",
                    bg_value: 0,
                    bg_img: { value: "", picview: "" },
                    radiusData: { top: 12, bottom: 12 },
                    btnData: { left: 12, radius: 20 },
                },
            },
        };
    },
    created() {
        // 获取传过来的参数
        this.diy_id = this.$route.query.diy_id;
        this.id = this.$route.query.id;
        this.diy_template_id = this.$route.query.diy_template_id;
        this.title = this.$route.query.title;
        // 1：产品模板，2：查询模板
        if (this.diy_id == 1) {
            this.getDiyManageSelects();
            this.getTemplateDiyManageInfo();
        } else if (this.diy_id == 2) {
            this.getTemplateQueryContent();
        }
    },
    computed: {
        xqBox() {
            return this.$refs.xqBox;
        },
    },
    mounted() {
        this.getSystemCompanyIndex();
        if (this.diy_id == 1) {
            this.getDiyManageSelect();
        }
        this.$nextTick(() => {
            this.xqBox.addEventListener("scroll", this.handleScroll);
        });
    },
    methods: {
        callMenuClick(e) {
            this.$refs.childRef.menuClick(e);
        },
        openPop() {
            this.popValue = !this.popValue;
        },
        closePop() {
            this.popValue = false;
        },
        handleScroll() {
            const scrollTop = this.xqBox.scrollTop;
            this.operateData.top_cha = scrollTop;
            console.log("滚动距离", scrollTop);
        },
        // 切换页面
        changePage(e) {
            if (e) {
                this.$Modal.confirm({
                    title: "跳转提示",
                    content: "是否确认跳转（" + e.label + "）",
                    onOk: () => {
                        this.link_value = true;
                        this.goSubmit();
                        this.$router.push({
                            path: `/admin/formwork/editDiy?id=${e.value}&diy_template_id=${this.diy_template_id}&diy_id=1`,
                        });
                        this.id = e.value;
                        this.getDiyManageSelect();
                        this.active_id = -1;
                        this.newFormData = {};
                        this.getTemplateDiyManageInfo();
                    },
                    onCancel: () => {
                        this.getDiyManageSelects();
                    },
                });
            }
        },
        getDiyManageSelects() {
            var data = {
                diy_template_id: this.$route.query.diy_template_id,
            };
            diy_manage_select(data)
                .then((res) => {
                    this.linkLists = res.data;
                    this.link_id = Number(this.$route.query.id);
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goReturn() {
            if (this.diy_id == 1) {
                this.$router.push({ path: "/admin/formwork/diy" });
            } else if (this.diy_id == 2) {
                this.$router.push({ path: "/admin/formwork/query" });
            }
        },
        // 内容设置（跳转页面）
        getDiyManageSelect() {
            var data = {
                diy_template_id: this.diy_template_id,
                id: this.id,
            };
            diy_manage_select(data)
                .then((res) => {
                    this.linkList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 获取公司信息
        getSystemCompanyIndex() {
            system_company_index()
                .then((res) => {
                    this.companyData.company_name = res.data.company_name;
                    this.companyData.logo = res.data.logo;
                    this.companyData.show_logo = res.data.show_logo;
                    this.companyData.license = res.data.license;
                    this.companyData.show_license = res.data.show_license;
                    this.companyData.other = res.data.other;
                    this.companyData.contact = res.data.contact;
                    this.companyData.mobile = res.data.mobile;
                    this.companyData.address = res.data.address;
                    this.companyData.pic = res.data.pic;
                    this.companyData.desc = res.data.desc;
                    this.companyData.show_other = res.data.show_other;
                    this.companyData.show_pic = res.data.show_pic;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // DIY模板内容
        getTemplateDiyManageInfo() {
            template_diy_manage_info({ id: this.id })
                .then((res) => {
                    if (res.data.title) {
                        this.title = res.data.title;
                    }
                    if (res.data.content) {
                        this.formData = res.data.content;
                        this.formData.forEach((item) => {
                            if (item.type == 21) {
                                if (item.content.version) {
                                    this.popData = item;
                                }
                            }
                            if (item.type == 0) {
                                if (item.content.version) {
                                    this.backgroundData = item;
                                }
                            }
                        });
                    } else {
                        this.formData = [];
                        // 背景设置
                        var value;
                        value = this.formData.some((item) => item.type == 0);
                        if (value) {
                            this.formData = this.formData.map((item) => {
                                if (item.type == 0) {
                                    return this.backgroundData;
                                }
                                return item;
                            });
                        } else {
                            this.formData.push(this.backgroundData);
                        }
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 查询模板内容
        getTemplateQueryContent() {
            template_query_content({ id: this.id })
                .then((res) => {
                    if (res.data.content) {
                        this.formData = res.data.content;
                        const formDataCopy = JSON.parse(
                            JSON.stringify(this.formData)
                        );
                        let value = formDataCopy.some(
                            (item) => item.type === -1
                        );
                        if (!value) {
                            // type != -1
                            formDataCopy.push(this.searchData);
                        } else {
                            let indexToRemove = -1;
                            for (let i = 0; i < formDataCopy.length; i++) {
                                const item = formDataCopy[i];
                                if (
                                    item.type === -1 &&
                                    (!item.content || item.content.version != 2)
                                ) {
                                    indexToRemove = i;
                                    break;
                                }
                            }
                            if (indexToRemove !== -1) {
                                formDataCopy.splice(indexToRemove, 1);
                            }
                        }
                        // 更新表单数据
                        this.formData = formDataCopy;

                        this.formData.forEach((item) => {
                            if (item.type == 21) {
                                if (item.content.version) {
                                    this.popData = item;
                                }
                            }
                            if (item.type == 0) {
                                if (item.content.version) {
                                    this.backgroundData = item;
                                }
                            }
                        });
                    } else {
                        this.formData = [];
                        // 背景设置
                        var value;
                        value = this.formData.some((item) => item.type == 0);
                        if (value) {
                            this.formData = this.formData.map((item) => {
                                if (item.type == 0) {
                                    return this.backgroundData;
                                }
                                return item;
                            });
                        } else {
                            this.formData.push(this.backgroundData);
                        }
                    }
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        clickActive(e, index, event) {
            this.active_id = index;
            this.newFormData = e;
            this.toShow(event);
            this.operateData.index = index;
            this.operateData.type = e.type;
        },
        toShow(event) {
            const parentElement = event.currentTarget;
            const rect = parentElement.getBoundingClientRect();
            this.operateData.visable = true;
            this.operateData.top = rect.top;
            this.operateData.left = rect.left + 380;
            this.operateData.first_top = this.xqBox.scrollTop;
        },
        // 删除
        delBtn(e) {
            this.formData.splice(e, 1);
            this.newFormData = "";
            this.active_id = -1;
            this.popValue = false;
            this.operateData.visable = false;
        },
        // 上移
        goMoveUp(index) {
            this.moveElement(this.formData, index, index - 1);
            this.active_id = index - 1;
            this.operateData.visable = false;
            console.log("this.formData", this.formData);
        },
        // 下移
        goMoveDown(index) {
            this.moveElement(this.formData, index, index + 1);
            this.active_id = index + 1;
            this.operateData.visable = false;
            console.log("this.formData", this.formData);
        },
        // 移动时
        onStart(e) {
            console.log("触发移动", e.oldDraggableIndex);
            this.drag = true;
            this.active_id = e.oldDraggableIndex;
        },
        // 移动结束
        onEnd(e) {
            console.log("移动结束", e.newDraggableIndex);
            this.drag = false;
            this.active_id = e.newDraggableIndex;
            this.newFormData = this.formData[this.active_id];
            console.log("onEnd", this.formData);
        },
        // 调整数组索性位置
        moveElement(array, fromIndex, toIndex) {
            // 从原位置移除元素
            const element = array.splice(fromIndex, 1)[0];
            // 将元素插入到新位置
            array.splice(toIndex, 0, element);
        },
        // 确定
        goSubmit() {
            // 调整组件顺序
            // 背景设置
            const index1 = this.formData.findIndex((item) => item.type == 0);
            if (index1 !== -1) {
                const backgroundItem = this.formData[index1];
                // 检查是否有 version 属性
                if (!backgroundItem.content.hasOwnProperty("version")) {
                    // 添加 version 属性并设置为 1
                    this.$set(backgroundItem.content, "version", 1);
                }
                // 将该项移动到数组首位
                this.moveElement(this.formData, index1, 0);
            }
            // 弹框组件
            const index2 = this.formData.findIndex((item) => item.type == 21);
            if (index2 != -1) {
                this.moveElement(this.formData, index2, 1);
            }
            if (this.diy_id == 1) {
                var data = {
                    id: this.id,
                    title: this.title,
                    content: this.formData,
                    diy_template_id: this.diy_template_id,
                };
                // 检查所有项是否都满足条件
                const allValid = this.formData.every((item) => {
                    return item.content && item.content.version;
                });
                if (!allValid) {
                    this.$Message.error("请更新组件，删除组件重新添加");
                    return; // 阻止后续操作
                }
                template_diy_save_manage(data)
                    .then((res) => {
                        if (!this.link_value) {
                            this.$Message.success(res.msg);
                        }
                        this.link_value = false;
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            } else if (this.diy_id == 2) {
                // this.formData = []
                var data = {
                    id: this.id,
                    content: this.formData,
                };
                // 检查所有项是否都满足条件
                const allValid = this.formData.every((item) => {
                    return item.content && item.content.version;
                });
                if (!allValid) {
                    this.$Message.error("请更新组件，删除组件重新添加");
                    return; // 阻止后续操作
                }
                template_modify_query(data)
                    .then((res) => {
                        this.$Message.success(res.msg);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            }
        },
        handleUpdateValue(newValue) {
            this.newFormData = newValue;
            this.active_id = -1;
            this.operateData.visable = false;
        },
        handleUpdateTitle(newValue) {
            this.title = newValue;
        },
    },
};
</script>
  
<style scoped>
.container {
    background-color: #f5f6fa;
}
.content {
    height: calc(100vh - 200px);
    margin-bottom: 80px;
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.content-component {
    min-width: 320px;
    flex: 2;
    overflow: auto;
}
.content-phone {
    margin: 0 24px;
    min-width: 450px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 4;
    overflow: hidden;
}
.content-style {
    height: calc(100vh - 200px);
    min-width: 440px;
    flex: 3;
    overflow: auto;
}
.phone {
    height: calc(100vh - 200px);
    position: relative;
    width: 376px !important;
    min-width: 376px !important;
    max-width: 376px !important;
    overflow-y: auto;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.footer {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 88px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #dcdee2;
    z-index: 999;
}
.phone-default {
    position: relative;
    width: 375px !important;
    cursor: pointer;
    z-index: 999;
}
.phone-active {
    position: relative;
    width: 375px !important;
    border: solid 2px #ff761d !important;
    cursor: pointer;
    z-index: 999;
}
/* draggable 拖拽的元素被选中时样式 */
.chosen {
    background-color: #ecf0f1;
    opacity: 0.8;
}
/* 删除组件 */
.del-btn {
    padding: 12px;
    cursor: pointer;
    background: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    z-index: 1000;
}
.pop {
    padding: 12px;
    background-color: rgb(226, 240, 255);
    color: #bebebe;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
}
.header {
    position: absolute;
    top: 10px;
    left: 10px;
    display: flex;
    align-items: center;
    z-index: 99;
}
.phone-div {
    width: 450px;
    min-width: 450px;
    max-width: 450px;
    overflow-x: hidden;
}
.bg-img {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    min-height: 100%;
    object-fit: cover; /* 填充整个区域（无变形裁剪） */
    display: block;
}
.w375 {
    width: 375px !important;
    min-width: 375px !important;
    max-width: 375px !important;
}
.w150 {
    width: 150px;
}
.cursor-p {
    cursor: pointer;
}
/* 滚动条整体部分 */
::-webkit-scrollbar {
    width: 1px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
    background-color: darkgrey;
}
/* 滚动条轨道 */
::-webkit-scrollbar-track {
    background: #f1f1f1;
}
.header-select ::v-deep .ivu-select-selection {
    border: none;
}
::v-deep
    .ivu-radio-group
    .ivu-radio-wrapper-checked
    .ivu-radio-checked
    .ivu-radio-inner {
    border: 2px solid #ff761d;
}
::v-deep
    .ivu-radio-group
    .ivu-radio-wrapper-checked
    .ivu-radio-checked
    .ivu-radio-inner:after {
    background-color: #fff;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
::v-deep .ivu-menu.ivu-menu-light.ivu-menu-horizontal {
    display: flex;
    align-items: center;
    justify-content: space-around;
}
::v-deep .ivu-menu-item {
    font-size: 16px;
}
::v-deep .ivu-menu-item:hover {
    font-size: 16px;
    color: #ff761d !important;
    border-bottom: 2px solid #ff761d !important;
}
::v-deep .ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected {
    color: #ff761d;
    font-size: 16px;
    border-bottom: 2px solid #ff761d !important;
}
::v-deep .ivu-form-item {
    margin-bottom: 6px !important;
}
</style>